export const SET_DATA = 'mp/equipment/SET_DATA';

export const initialState = {
  loaded: false,
  equipment: []
};

export const equipment = (state = initialState, action = {}) => {
  switch (action.type) {

    case SET_DATA:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};

export default equipment;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/equipment/equipment.js
 **/